import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import './Contact.css';

function Contact() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        alert('¡Gracias por contactar con nosotros! Te responderemos pronto.');
        setFormData({ name: '', email: '', subject: '', message: '' });
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    return (
        <div className="page-container contact-page">
            <Navbar />

            <section className="contact-hero">
                <div className="container">
                    <div className="contact-hero-content">
                        <span className="section-badge">CONTACTO</span>
                        <h1 className="contact-title">
                            Siempre estamos para <span className="gradient-text">ayudarte</span>
                        </h1>
                        <p className="contact-subtitle">
                            ¿Tienes preguntas o comentarios? Nos encantará escucharlos.
                        </p>
                    </div>
                </div>
            </section>

            <section className="contact-content">
                <div className="container">
                    <div className="contact-grid">
                        <div className="contact-info">
                            <h2>Información de contacto</h2>
                            <p className="info-subtitle">Completa el formulario y nuestro equipo se pondrá en contacto contigo en 24 horas.</p>

                            <div className="contact-cards">
                                <div className="contact-card">
                                    <div className="contact-icon">📧</div>
                                    <h3>Email</h3>
                                    <p>hello@talktokrishna.ai</p>
                                </div>

                                <div className="contact-card">
                                    <div className="contact-icon">💬</div>
                                    <h3>Chat en vivo</h3>
                                    <p>Disponible 24/7</p>
                                </div>

                                <div className="contact-card">
                                    <div className="contact-icon">🌐</div>
                                    <h3>Redes sociales</h3>
                                    <div className="social-links">
                                        <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-link">Twitter</a>
                                        <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-link">LinkedIn</a>
                                        <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-link">Instagram</a>
                                    </div>
                                </div>
                            </div>

                            <div className="faq-section">
                                <h3>Preguntas frecuentes</h3>
                                <div className="faq-item">
                                    <strong>¿Cómo funciona la IA??</strong>
                                    <p>Nuestra IA utiliza tecnología RAG para buscar en más de 700 versos auténticos del Bhagavad Gita.</p>
                                </div>
                                <div className="faq-item">
                                    <strong>¿Es gratis?</strong>
                                    <p>¡Sí! El uso básico de "Habla con Krishna" es gratuito para todos los usuarios.</p>
                                </div>
                                <div className="faq-item">
                                    <strong>¿Qué idiomas son compatibles?</strong>
                                    <p>Actualmente admitimos español e inglés.</p>
                                </div>
                            </div>
                        </div>

                        <div className="contact-form-wrapper">
                            <form onSubmit={handleSubmit} className="contact-form">
                                <h2>Enviar mensaje</h2>

                                <div className="form-group">
                                    <label>Tu nombre</label>
                                    <input
                                        type="text"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        placeholder="Arjuna"
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Correo electrónico</label>
                                    <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        placeholder="you@example.com"
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Asunto</label>
                                    <input
                                        type="text"
                                        name="subject"
                                        value={formData.subject}
                                        onChange={handleChange}
                                        placeholder="¿De qué trata tu mensaje?"
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Mensaje</label>
                                    <textarea
                                        name="message"
                                        value={formData.message}
                                        onChange={handleChange}
                                        placeholder="Describe tu pregunta o comentario con más detalle..."
                                        rows="5"
                                        required
                                    ></textarea>
                                </div>

                                <button type="submit" className="btn-premium-primary btn-large">
                                    <span className="btn-icon">📨</span>
                                    Enviar
                                    <span className="btn-arrow">→</span>
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Contact;
